<template>
  <div id="guide">
    <div class="banner">
      <img
        class="banner_img"
        src="../../../static/images/guide/dtbanner.jpg"
        alt=""
      />
    </div>
    <div class="branch">
      <!-- <div class="branch_hall"  @click="goBranch('/newpublish')">
        <span>移动网签</span>
      </div> -->
      <!-- <div class="branch_hall"  @click="goBranch('/newpublish')">
        <span>中介网签</span>
      </div> -->
      <div class="branch_yuyue" @click="goBranch('/appointmentGuide')">
        <span>在线预约</span>
      </div>
      <!-- <div class="branch_chaxun" @click="goBranch('/progress')">
        <span>进度查询</span>
      </div> -->
      <div class="branch_info" @click="goBranch('/infoAndNumbering')">
        <span>信息查询</span>
      </div>

      <!-- 上线版本 -->
      <div class="branch_check" @click="goBranch('/onlineHandle')">
        <span>线上申办</span>
      </div>
      <!-- <div class="branch_enter" @click="goBranch('/familyEnterNotice')">
        <span>家庭成员录入</span>
      </div> -->

      <!-- <div class="branch_news" @click="goBranch('/allQuestionList')"> -->
      <div class="branch_news" @click="goBranch('/cjwt')">
        <!-- <span>有问必答</span> -->
        <span>常见问题</span>
      </div>
      <!-- <div class="branch_guide" @click="goBranch('/handleList')"> -->
      <div class="branch_guide" @click="goBranch('/bszn')">
        <span>办事指南</span>
      </div>
      <div class="branch_jiaofei">
        <wx-open-launch-weapp
          @launch="handleLaunchFn"
          @error="handleErrorFn"
          id="launch-btn"
          appid="wx9689954eef9f55bf"
          username=""
          path=""
        >
          <script type="text/wxtag-template">
            <style>.btn { width: 135px; height: 75px }</style>
            <div class="btn"></div>
          </script>
        </wx-open-launch-weapp>
        <span>移动缴费</span>
      </div>
      <div class="branch_jiaoshui" @click="goBranch('/selfpay')">
        <span>移动缴税</span>
      </div>
      <div class="financial_info" @click="goBranch('/financialServices')">
        <span>金融服务</span>
      </div>
      <!-- <div class="branch_main" @click="goBranch('/taofang')">
        <span>淘房网</span>
      </div> -->
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import { GET_JSSDK_CONFIG } from "../../constants/index";
export default {
  mounted() {
    this.getJSSDKConfig(); //测试，需要取消注释
  },
  methods: {
    handleLaunchFn(val) {
      // console.log(val);
    },
    handleErrorFn(val) {
      // console.log(val);
    },
    getJSSDKConfig() {
      this.showLoading = true;
      this.$fetch(GET_JSSDK_CONFIG, {
        signurl: window.location.href.split("#")[0]
      })
        .then(res => {
          if (res.Status == 1) {
            this.toConfig(res);
          } else {
            // Toast(res.Message);
          }
        })
        .catch(res => {
          // Toast(res.Message);
        });
    },
    toConfig(res) {
      wx.config({
        beta: true,
        appId: res.Data.appid,
        timestamp: res.Data.timestamp,
        nonceStr: res.Data.noncestr,
        signature: res.Data.signature,
        jsApiList: ["onMenuShareTimeline", "chooseImage"], // 必填，需要使用的JS接口列表
        openTagList: ["wx-open-launch-weapp"]
      });
      wx.ready(res => {
        // console.log(res);
      });
      wx.error(function(res) {
        // Toast(res);
        // console.log(res);
        //可以更新签名
      });
    },
    goBranch(index) {
      if (index == "/payment") {
        window.location.href =
          "http://csfs.hnfspay.com/bdc_query?dwbm=3219&dwmc=%E9%95%BF%E6%B2%99%E5%B8%82%E4%B8%8D%E5%8A%A8%E4%BA%A7%E7%99%BB%E8%AE%B0%E4%B8%AD%E5%BF%83&czqhnm=0000000003&CityServices=1";
      } else if (index == "/selfpay") {
        window.location.href =
          "http://bdcjy.hunan.chinatax.gov.cn:6001/index.html";
      } else if (index == "/newsList") {
        window.location.href =
          "http://zygh.changsha.gov.cn/csbdc/Home/Contact/?BName=%E6%9C%89%E9%97%AE%E5%BF%85%E7%AD%94&BCODE=0F9D2B34C0264BB5A684570F341014EA";
      } else if (index == "/cjwt") {
        window.location.href =
          "http://zygh.changsha.gov.cn/ywpd/bmfw_136231/cjwt_51FE/";
      } else if (index == "/bszn") {
        window.location.href =
          "http://zygh.changsha.gov.cn/ywpd/bmfw_136231/bszn/";
      } else {
        this.$router.push({ path: index });
      }
    }
  }
};
</script>

<style lang="less">
#guide {
  background-color: #fff;

  .banner {
    width: 100%;
    height: 300px;

    .banner_img {
      width: 100%;
      height: 100%;
    }
  }

  .branch {
    padding-bottom: 150px;

    .branch_hall,
    .branch_main,
    .branch_guide,
    .branch_news,
    .branch_yuyue,
    .branch_jiaofei,
    .branch_chaxun,
    .branch_check,
    .branch_enter,
    .branch_jiaoshui,
    .branch_info,
    .financial_info {
      position: relative;
      display: inline-block;
      vertical-align: top;
      width: 330px;
      height: 180px;
      margin-top: 30px;
      margin-left: 30px;
      font-size: 32px;
      font-weight: bold;
      color: #fff;

      span {
        position: absolute;
        width: fit-content;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    .branch_enter span {
      white-space: nowrap;
    }

    .branch_hall {
      background: url("../../../static/images/guide/icon_1@2x.png") center
        center no-repeat;
      background-size: 100% 100%;
    }

    .branch_main {
      background: url("../../../static/images/guide/icon_10@2x.png") center
        center no-repeat;
      background-size: 100% 100%;
    }

    .branch_info {
      background: url("../../../static/images/guide/icon_9@2x.png") center
        center no-repeat;
      background-size: 100% 100%;
    }

    .branch_guide {
      background: url("../../../static/images/guide/icon_3@2x.png") center
        center no-repeat;
      background-size: 100% 100%;
    }

    .branch_news {
      background: url("../../../static/images/guide/icon_4@2x.png") center
        center no-repeat;
      background-size: 100% 100%;
    }

    .branch_yuyue {
      background: url("../../../static/images/guide/icon_5@2x.png") center
        center no-repeat;
      background-size: 100% 100%;
    }

    .branch_jiaofei {
      background: url("../../../static/images/guide/icon_6@2x.png") center
        center no-repeat;
      background-size: 100% 100%;
    }

    .branch_chaxun {
      background: url("../../../static/images/guide/icon_7@2x.png") center
        center no-repeat;
      background-size: 100% 100%;
    }

    .branch_check {
      background: url("../../../static/images/guide/icon_11.png") center center
        no-repeat;
      background-size: 100% 100%;
    }

    .branch_enter {
      background: url("../../../static/images/guide/icon_11.png") center center
        no-repeat;
      background-size: 100% 100%;
    }

    .branch_jiaoshui {
      background: url("../../../static/images/guide/icon_8@2x.png") center
        center no-repeat;
      background-size: 100% 100%;
    }

    .financial_info {
      background: url("../../../static/images/guide/financial@2x.png") center
        center no-repeat;
      background-size: 100% 100%;
    }
  }

  #launch-btn {
    z-index: 100;
    position: absolute;
    overflow: hidden;
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/guide/guide.vue